export enum AddView_GroupType {
    GROUP       = 'group',
    SEPARATOR   = 'separator'
}

export type AddView_Group = {
    type            : AddView_GroupType
    id?             : ID
    icon?           : string
    title?          : string
    skipItemsList?  : boolean // skip showing group items list and show first item form
    items?          : (AddView_OptionConfig|null)[]
}

export type AddView_OptionConfig = {
    typeId                  : any
    iconSvg?                : string
    title                   : string
    description?            : string
    isPro?                  : boolean   // item requires license upgrade
    proFeature?             : any       // to show specific upgrade modal if necessary
    alreadyExists?          : boolean   // for single views to mark they're already added

    onClick?                : func      // use this to redefine default click

    formParams?             : any       // any additional params to use in formComponent
    formComponent?          : any       // render form component on click instead of calling any function
}